<div class="pending-issues-wrapper">
  <div mat-dialog-title>
    <header>{{ 'commonLabels.pendingIssues' | xTranslate }}</header>
    <button mat-icon-button class="dialog-close" mat-dialog-close>
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>
  <div mat-dialog-content>
    <ng-container *ngIf="pendingIssuesData$ | async as pendingIssuesData; else noIssues">
      <form class="issues-filters" [formGroup]="pendingIssuesFG">
        <p>{{ 'pendingIssues.filterBy' | xTranslate }}</p>
        <mat-checkbox formControlName="unknown" class="checkbox-input">{{
          'commonLabels.unknown' | xTranslate
        }}</mat-checkbox>
        <mat-checkbox formControlName="expired" class="checkbox-input">{{
          'commonLabels.expired' | xTranslate
        }}</mat-checkbox>
        <p>
          <span>{{ pendingIssuesData.length }}</span> {{ 'pendingIssues.items' | xTranslate }}
        </p>
      </form>
      <p-table
        class="p-datatable-custom"
        [value]="pendingIssuesData"
        [columns]="issuesTableHeader"
        [customSort]="true"
        [resetPageOnSort]="false"
        [paginator]="true"
        [rows]="defaultRows"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="rowsOptions"
        paginatorDropdownAppendTo="body"
        (sortFunction)="sortPendingIssues($event)"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" scope="col">
              <span class="sort-header"
                >{{ col.header | xTranslate }}
                <p-sortIcon [field]="col.field"></p-sortIcon>
              </span>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-issue>
          <tr class="navigate-class" (click)="navigateToRecords(issue)">
            <td>{{ issue.name }}</td>
            <td>{{ issue.recordType | titlecase }}</td>
            <td>{{ issue.id }}</td>
            <td [class.error-flag]="issue.floor.error">{{ issue.floor.value || ('commonLabels.na' | xTranslate) }}</td>
            <td [class.error-flag]="issue.suite.error">{{ issue.suite.value || ('commonLabels.na' | xTranslate) }}</td>
            <td [class.error-flag]="issue.spaceSize.error">
              {{ issue.spaceSize.value || ('commonLabels.na' | xTranslate) }}
            </td>
            <td [class.error-flag]="issue.startDate.error">
              {{ (issue.startDate.value | getDateString) || ('commonLabels.na' | xTranslate) }}
            </td>
            <td [class.error-flag]="issue.endDate.error">
              {{ (issue.endDate.value | getDateString) || ('commonLabels.na' | xTranslate) }}
            </td>
            <td [class.error-flag]="issue.status.error">
              {{ issue.status.value || ('commonLabels.na' | xTranslate) }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>
  </div>
</div>

<ng-template #noIssues>
  <p class="no-issues">{{ 'commonLabels.noIssues' | xTranslate }}</p>
</ng-template>
